import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Fab, Menu, MenuItem, InputAdornment, TextField } from "@mui/material";
import {
  AddCircle,
  EmojiEmotions,
  Message,
  MoreVert,
} from "@mui/icons-material";
import "./chat.scss";

interface Props {
  setOpenChatBox: React.Dispatch<React.SetStateAction<boolean>>;
}

const Chat = ({ setOpenChatBox }: Props) => {
  const [message, setMessage] = useState<string[]>([]);
  const [addComment, setAddComment] = useState<string>("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openChatMenu = Boolean(anchorEl);

  const navigate = useNavigate();
  const support: boolean = false;

  const chatCommentHandler = (event: React.FormEvent) => {
    event.preventDefault();
    setMessage([...message, addComment]);
    setAddComment("");
  };

  return (
    <div className="chatBox">
      <Box
        className="text-white"
        justifyContent="space-between"
        display="flex"
        sx={{ p: "15px" }}
      >
        <div className="chatbox-header">
          <h2 className="heading">Welcome!</h2>
          <p className="fs-12">Question? Chat with us.</p>
          <span className="fs-12 status">
            Support is {support ? "Online" : "Offline"}
          </span>
        </div>
        <Box>
          <i
            id="basic-button"                                                                                      
            aria-controls={openChatMenu ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openChatMenu ? "true" : undefined}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
              setAnchorEl(event.currentTarget)
            }
            className="cursor-pointer"
          >
            <MoreVert />
          </i>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openChatMenu}
            onClose={() => setAnchorEl(null)}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                width: 125,
                "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                navigate("/help");
                setOpenChatBox(false);
              }}
            >
              Help Articles
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate("/my-enquiries");
                setOpenChatBox(false);
              }}
            >
              My Enquiries
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      <Box sx={{ backgroundColor: "#fff", borderRadius: "10px" }}>
        <Box sx={{ p: "5px 13px", height: "280px", overflowY: "scroll" }}>
          <Box className="defaultRecieviedMessages">
            <Box display="flex" alignItems="center">
              <Fab
                size="small"
                sx={{
                  "&:hover": { backgroundColor: "#434242" },
                  backgroundColor: " #434242",
                  height: "10px",
                  width: "35px",
                  position: "relative",
                  top: "23px",
                }}
                disableRipple
                disableFocusRipple
              >
                <Message sx={{ color: "#fff", fontSize: "15px" }} />
              </Fab>
              <Box className="messages fs-12">
                <p className="recievedMessage border-radius-4">Hi!</p>
                <p className="recievedMessage border-radius-4">
                  What can i help you with?
                </p>
              </Box>
            </Box>
            <small className="messageTime fs-10">10:12 Am, Today</small>
          </Box>
          <Box className="defaultReceivedOptions">
            <p className="recievedOptions border-radius-10 fs-10">
              Do you want to Pay PCN?
            </p>
            <p className="recievedOptions border-radius-10 fs-10">
              Do you need to get help with your appeal?
            </p>
          </Box>
          <Box sx={{ float: "right" }}>
            {message.map((item: string) => (
              <p className="newComment border-radius-4 fs-12" key={item}>
                {item}
              </p>
            ))}
          </Box>
        </Box>
        <Box>
          <form onSubmit={chatCommentHandler}>
            <TextField
              type="text || submit"
              name="comment"
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Type text here..."
              sx={{ backgroundColor: "white" }}
              value={addComment}
              onChange={(e) => setAddComment(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <EmojiEmotions sx={{ color: "#ADADAE" }} />
                    <AddCircle sx={{ color: "#ADADAE" }} />
                  </InputAdornment>
                ),
              }}
            />
          </form>
        </Box>
      </Box>
    </div>
  );
};

export default Chat;
